/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react'
import PropTypes from 'prop-types'
import {Flex, Text, useMultiStyleConfig} from '@chakra-ui/react'
import {remCalc} from '../../theme/_utils'

const AddressDisplay = ({address, isConfirmation = false, isTitleBold = false}) => {
    const nameStyle = isConfirmation && isTitleBold ? {fontWeight: 'bold'} : {}
    const confirmationGap = isConfirmation ? {gap: remCalc(4)} : {}
    const styles = useMultiStyleConfig('AddressDisplay', {})

    return (
        <Flex {...styles.addressContainer} style={confirmationGap}>
            {address?.c_fiscalCode && <Text mb={remCalc(16)}>{address.c_fiscalCode}</Text>}
            {address?.c_companyName && <Text>{address.c_companyName}</Text>}
            {address?.c_vatNumber && <Text>{address.c_vatNumber}</Text>}
            {address?.c_sdi && <Text>{address.c_sdi}</Text>}
            {(address?.c_companyName || address?.c_vatNumber || address?.c_sdi) && <>&nbsp;</>}
            <Text style={nameStyle}>
                {address?.firstName} {address?.lastName}
            </Text>
            <Text>{address?.phone}</Text>
            <Text>{address?.address1}</Text>
            {address?.address2 && <Text>{address?.address2}</Text>}
            <Text>
                {address?.city}, {address?.c_regionName}, {address?.postalCode}
            </Text>
        </Flex>
    )
}

AddressDisplay.propTypes = {
    address: PropTypes.object,
    isConfirmation: PropTypes.bool,
    isTitleBold: PropTypes.bool,
}

export default AddressDisplay
